export class JobProgressStepTableConfigurationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "throughputMode",
            "baseName": "throughputMode",
            "type": "string",
            "format": ""
        },
        {
            "name": "readCapacityUnits",
            "baseName": "readCapacityUnits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "writeCapacityUnits",
            "baseName": "writeCapacityUnits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sourceCapacityMode",
            "baseName": "sourceCapacityMode",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepTableConfigurationData.attributeTypeMap;
    }
    constructor() {
    }
}
